export default {
  listRegistrationsTypes: [],
  registrationType: {
    nome: '',
    valor: '',
    ativo: true,
    tipo: null,
    tiposFaixaPadrao: [],
    tipoPagamentoPadrao: null,
    contaPadrao: null,
  },
  comboTypes: [],
  comboTipoFaixa: [],
  comboTipoPagamento: [],
  comboContas: [],
}
